module.exports = __webpack_public_path__ + "static/img/gya_2020.ef1a784.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/line/gya_2020.png
// module id = En4d
// module chunks = 0